
      var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsInternet = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h32v32H0z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "M2.759 5.198c0-.738.602-1.336 1.313-1.336h23.856c.725 0 1.313.594 1.313 1.336v18.7c0 .738-.602 1.336-1.313 1.336H4.072c-.35 0-.685-.142-.932-.393a1.334 1.334 0 0 1-.381-.943v-18.7zm2.648 1.336v16.029h21.186V6.533H5.407zM6.73 26.57h18.54v2.671H6.731V26.57z"
}))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"32\" height=\"32\" viewBox=\"0 0 32 32\">\r\n    <g fill=\"none\" fill-rule=\"evenodd\" opacity=\"1\">\r\n        <g>\r\n            <g>\r\n                <path d=\"M0 0L32 0 32 32 0 32z\" transform=\"translate(-1372 -373) translate(1372 373)\"/>\r\n                <path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M2.759 5.198c0-.738.602-1.336 1.313-1.336h23.856c.725 0 1.313.594 1.313 1.336v18.7c0 .738-.602 1.336-1.313 1.336H4.072c-.35 0-.685-.142-.932-.393-.246-.25-.383-.59-.381-.943v-18.7zm2.648 1.336v16.029h21.186V6.533H5.407zM6.73 26.57H25.27v2.671H6.731V26.57z\" transform=\"translate(-1372 -373) translate(1372 373)\"/>\r\n            </g>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-internet.f429e6ad8b406bfab42cc229daa6eb9a.svg"),
        {
          React: SvgIconsInternet,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      